import React from "react";

const Eyebrow = () => <span className="hero__eyebrow">Community</span>;

export default Eyebrow;
